import {SNACKBAR_CLOSE, SNACKBAR_OPEN} from "@store/actions";
import {SnackbarAction} from "@store/actions/snackbar.action";

export interface SnackbarState {
  show: boolean;
}

export function snackbarReducer(
  state: SnackbarState = {
    show: false
  },
  action: SnackbarAction
) {
  switch(action.type) {
    case SNACKBAR_CLOSE:
      return { ...state, show: false };
    case SNACKBAR_OPEN:
      return { ...state, show: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/snackbar.reducer.ts